// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-float-right {\n  float: right; }\n\n.text-inside-button {\n  color: white !important; }\n\n.invalid-input-error {\n  color: red; }\n\n.get-batch-button-margin {\n  margin: 20px; }\n\n.select-drop-down div {\n  position: relative !important; }\n", ""]);
// Exports
module.exports = exports;
